export default function ChiSiamo() {

    return(
        <div className="flex-col p-4 pt-0 xl:pl-20 xl:pr-20 items-center justify-center ">
            <h1 className="text-4xl font-bold text-center p-4">Chi siamo</h1>

<div
  className="relative flex flex-col items-center bg-cover bg-center rounded-xl h-128 sm:h-144"
  style={{ backgroundImage: `url('./images/dot-lavoratori.webp')` }}
>
                <div className="absolute bottom-0 left-0 w-full h-3/6 bg-gradient-to-t from-white to-transparent rounded-b-xl"></div>

                <div className="flex flex-col items-center bg-cover w-full h-full rounded-xl p-4 relative font-medium">
                    <div className="absolute top-0 left-0 w-full h-1/6 bg-gradient-to-b from-white to-transparent rounded-b-xl"></div>

                    <p className="text-center sm:w-96 mt-4 text-lg font-semibold rounded-xl z-10">
                        Siamo un'azienda nata dalla passione e dalle competenze di due giovani imprenditori nel campo degli infissi su misura.
                    </p>

                    <p className="text-center w-10/12 lg:w-3/4 sm:text-lg font-semibold rounded-xl absolute bottom-2 z-10">
                        Siamo Matteo e Davide, la nostra esperienza e dedizione per questo lavoro ci ha portato all'apertura di un'azienda alla sola età di 24 anni.
                        <br/>L'obiettivo di DOT Serramenti è la soddisfazione del cliente da tutti i punti di vista e 
                        la creazione di un rapporto di fiducia e trasparenza con esso, al fine 
                        di soddisfare al meglio le sue esigenze.
                    </p>
                    <div className="absolute bottom-0 left-0 w-full h-3/6 bg-gradient-to-t from-white to-transparent rounded-b-xl"></div>

                </div>
            </div>
        </div>
    );
}